import {
  createApi,
} from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from './baseQuery'

const UserTag = 'User'

export const api = createApi({
  reducerPath: 'user',
  tagTypes: [UserTag],
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getMyUser: build.query<IUserModel, any>({
      query: () => '/api/v2/users/me',
      providesTags: (result) =>
        result && result._id ? [{ type: UserTag, id: result._id }] : [],
    }),
    createUser: build.mutation<IUserModel, Partial<IUserModel>>({
      query: (body) => ({
        url: '/api/v2/users',
        method: 'POST',
        body,
      }),
      invalidatesTags: [UserTag],
    }),
    // auth
    login: build.mutation<IAuthResponse, IAuthSignin>({
      query: (body) => ({
        url: '/auth/local',
        method: 'POST',
        body,
      }),
      invalidatesTags: [UserTag]
    }),
    signup: build.mutation<IAuthResponse, IAuthSignup>({
      query: (body) => ({
        url: '/api/v2/users',
        method: 'POST',
        body,
      }),
      invalidatesTags: [UserTag]
    }),
    requestPasswordReset: build.mutation<void, IAuthRequestReset>({
      query: (body) => ({
        url: '/api/v2/users/reset',
        method: 'POST',
        body,
      }),
      invalidatesTags: [UserTag]
    }),
    resetPassword: build.mutation<IAuthResponse, IAuthResetPassword>({
      query: (body) => ({
        url: '/api/v2/users/reset',
        method: 'PUT',
        body,
      }),
      invalidatesTags: [UserTag]
    }),
  }),
})

export const {
  useGetMyUserQuery,
  useCreateUserMutation,
  useLoginMutation,
  useSignupMutation,
  useRequestPasswordResetMutation,
  useResetPasswordMutation,
} = api

